import * as React from 'react';
import { useState } from 'react';
import {
    useListContext,
    useNotify,
    useRefresh,
    useUnselectAll,
} from 'react-admin';
import SelectTagsDialog from './select-tags-dialog';
import { Button } from '@mui/material';
import { dataProvider } from '../../../DataProvider';
import { AddCircleOutline, RemoveCircleOutline } from '@mui/icons-material';

interface IData {
    [key: string]: any;
}

const TagActions: React.FC<IData> = ({ display, tags, reload }) => {
    const { selectedIds, data, resource } = useListContext();
    const notify = useNotify();
    const refresh = useRefresh();
    const unselectAll = useUnselectAll(resource);

    const [dialogOpen, setDialogOpen] = useState(false);
    const [mode, setMode] = useState(null); // 'add' or 'remove'

    if (!display) return;

    const openDialog = (mode) => {
        setMode(mode);
        setDialogOpen(true);
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    // This is the core logic for updating tags
    const handleSave = (selectedTags) => {
        handleDialogClose();

        let selectedRows = data.filter((row: any) => selectedIds.includes(row.id));
        selectedRows.forEach(x => {
            x.sm_event_id = x.id;
            x.sm_tags = `,${selectedTags},`;
            x.remove_tags = mode === 'remove';
            x.bulk_update = true;
        });
        dataProvider.postData('SmEventCheck', 'UpdateTags', selectedRows)
            .then((response: any) => {
                if (response?.data?.length) {
                    notify('Events updated successfully', { type: 'success' });
                    refresh();
                } else {
                    notify(`Error: ${response?.body}`, { type: 'error' });
                }
            })
            .catch((error: any) => {
                notify(`Error: ${error.message}`, { type: 'error' });
            })
            .finally(() => {
                refresh();
                unselectAll();
                reload();
            });
    };

    return (
        <>
            <Button sx={{
                backgroundColor: '#4caf50',
                color: 'white',
                textTransform: 'none',
                fontWeight: 600,
                '&:hover': {
                    backgroundColor: '#388e3c',
                },
            }}
            variant='contained'
            startIcon={<AddCircleOutline />}
            onClick={() => openDialog('add')}
            >
                Add Tags
            </Button>

            <Button sx={{
                backgroundColor: '#f44336',
                color: 'white',
                textTransform: 'none',
                fontWeight: 600,
                '&:hover': {
                    backgroundColor: '#d32f2f',
                },
            }}
            variant='contained'
            startIcon={<RemoveCircleOutline />}
            onClick={() => openDialog('remove')}
            >
                Remove Tags
            </Button>
            <SelectTagsDialog
                tags={tags}
                open={dialogOpen}
                mode={mode}
                onClose={handleDialogClose}
                onSave={handleSave}
            />
        </>
    );
};
export default TagActions;